<template>
    <div>
        <v-card class="mt-4">
            <v-card-title class="pa-2">
                <v-btn color="primary" class="m-0" @click="onBackKey"><v-icon left>mdi-arrow-left-bold-circle-outline</v-icon>Back</v-btn>
                <v-spacer></v-spacer>
                <label v-text="createDescription"></label>
                <v-spacer></v-spacer>
            </v-card-title>
        </v-card>
        <v-card class="mt-2" >
            <v-stepper non-linear v-model="licenseStep" alt-labels>
                <v-stepper-header>
                    <v-stepper-step step="C">Count</v-stepper-step>
                    <v-divider></v-divider>
                    <v-stepper-step step="D">Dealer</v-stepper-step>
                    <v-divider></v-divider>
                    <v-stepper-step step="F">Firm</v-stepper-step>
                    <v-divider></v-divider>
                    <v-stepper-step step="E">Expires</v-stepper-step>
                    <v-divider></v-divider>
                    <v-stepper-step step="X">Instance Limit</v-stepper-step>
                    <v-divider></v-divider>
                    <v-stepper-step step="P">Products</v-stepper-step>
                    <v-divider></v-divider>
                    <v-stepper-step step="T">Type</v-stepper-step>
                    <v-divider></v-divider>
                    <v-stepper-step step="+">Confirmation</v-stepper-step>
                    <v-divider></v-divider>
                    <v-stepper-step step="L">Licenses</v-stepper-step>
                </v-stepper-header>
                <v-stepper-content step="C">
                    <v-card>
                        <v-card-title class="pa-2">
                            <label>Count</label>
                        </v-card-title>
                        <v-card-text>
                            <v-container>
                                <v-layout >
                                    <v-col cols="12">
                                        <v-row class="pt-1">
                                            <v-col class="pr-4">
                                            <v-slider v-model="creating.createSlider" class="align-center" :max="createMax" :min="createMin" hide-details thumb-label="always" thumb-size="32">
                                            </v-slider>
                                            </v-col>
                                        </v-row>
                                        <v-row class="pt-1">
                                            <v-col>
                                            </v-col>
                                            <v-col>
                                            </v-col>
                                            <v-col>
                                                <v-btn color="primary" class="mb-6" @click="onCountClick(5)" block>5</v-btn>
                                                <v-btn color="primary" class="mb-5" @click="onCountClick(10)" block>10</v-btn>
                                                <v-btn color="primary" class="mb-5" @click="onCountClick(15)" block>15</v-btn>
                                                <v-btn color="primary" class="mb-5" @click="onCountClick(20)" block>20</v-btn>
                                                <v-btn color="primary" class="mb-5" @click="onCountClick(25)" block>25</v-btn>
                                                <v-btn color="primary" class="mb-5" @click="onCountClick(50)" block>50</v-btn>
                                            </v-col>
                                            <v-col>
                                            </v-col>
                                            <v-col>
                                            </v-col>
                                        </v-row>
                                    </v-col>
                                </v-layout>
                            </v-container>
                        </v-card-text>
                        <v-card-actions>
                            <v-spacer></v-spacer>
                            <v-btn color="primary" class="m-0" @click="nextStep">Next</v-btn>
                        </v-card-actions>
                    </v-card>
                </v-stepper-content>
                <v-stepper-content step="D">
                    <v-card>
                        <v-card-title class="pa-2">
                            <label>Dealer</label>
                        </v-card-title>
                        <v-card-text>
                            <v-data-table dense v-model="dealerTable.selected" :single-select="dealerTable.singleSelect" show-select item-key="dealerGUID" :headers="dealerTable.headers" :items="dealerTable.dealers" :search="dealerTable.filter" :loading="isBusy" :loading-text="dealerTable.loadingText" class="elevation-0">
                            </v-data-table>
                        </v-card-text>
                        <v-card-actions>
                            <v-btn color="primary" class="m-0" @click="previousStep">Previous</v-btn>
                            <v-spacer></v-spacer>
                            <v-btn color="primary" class="m-0" @click="nextStep">Next</v-btn>
                        </v-card-actions>
                    </v-card>
                </v-stepper-content>
                <v-stepper-content step="E">
                    <v-card>
                        <v-card-title class="pa-2">
                            <label>Expires</label>
                            <v-spacer></v-spacer>
                        </v-card-title>
                        <v-card-text>
                            <v-container>
                                <v-layout >
                                    <v-col cols="12">
                                        <v-row>
                                            <v-spacer/>
                                            <v-col>
                                                <v-date-picker v-model="expires"></v-date-picker>
                                            </v-col>
                                            <v-col>
                                                <v-btn color="primary" class="mb-6" @click="onExpirationClick(0)" block><v-icon left>mdi-calendar</v-icon>This Month</v-btn>
                                                <v-btn color="primary" class="mb-5" @click="onExpirationClick(1)" block>1 Month</v-btn>
                                                <v-btn color="primary" class="mb-5" @click="onExpirationClick(3)" block>3 Months</v-btn>
                                                <v-btn color="primary" class="mb-5" @click="onExpirationClick(6)" block>6 Months</v-btn>
                                                <v-btn color="primary" class="mb-5" @click="onExpirationClick(12)" block>12 Months</v-btn>
                                                <v-btn color="primary" class="mb-5" @click="onExpirationClick(18)" block>18 Months</v-btn>
                                                <v-btn color="primary" class="mb-5" @click="onExpirationClick(24)" block>24 Months</v-btn>
                                            </v-col>
                                            <v-spacer/>
                                        </v-row>
                                    </v-col>
                                </v-layout>
                            </v-container>
                        </v-card-text>
                        <v-card-actions>
                            <v-btn color="primary" class="m-0" @click="previousStep">Previous</v-btn>
                            <v-spacer></v-spacer>
                            <v-btn color="primary" class="m-0" @click="nextStep">Next</v-btn>
                        </v-card-actions>
                    </v-card>
                </v-stepper-content>
                <v-stepper-content step="F">
                    <v-card>
                        <v-card-text>
                            <v-card class="pa-0 ma-0" elevation="0">
                                <v-card-title class="pa-2">
                                    <v-row>
                                        <v-col>
                                            <label><v-icon left>mdi-account-search</v-icon>Search</label>
                                        </v-col>
                                        <v-col cols="6">
                                            <v-text-field ref="searchFor" label="Firm Code or Name Part " prepend-icon="mdi-magnify" v-model="firmTable.searchFor" outlined dense single-line rounded clearable hide-details @keyup.native="onFirmSearchKey"></v-text-field>
                                        </v-col>
                                        <v-col>
                                            <v-btn color="primary" class="ml-4" @click="confirmSearchFirms"><v-icon left>mdi-account-search</v-icon>Search</v-btn>
                                        </v-col>
                                    </v-row>
                                </v-card-title>
                                <v-data-table dense v-model="firmTable.selected" :single-select="firmTable.singleSelect" show-select item-key="firmGUID" :headers="firmTable.headers" :items="firmTable.firms" :search="firmTable.filter" :loading="isBusy" :loading-text="firmTable.loadingText" class="elevation-0">
                                </v-data-table>
                            </v-card>
                        </v-card-text>
                        <v-card-actions>
                            <v-btn color="primary" class="m-0" @click="previousStep">Previous</v-btn>
                            <v-spacer></v-spacer>
                            <v-btn color="primary" class="m-0" @click="nextStep">Next</v-btn>
                        </v-card-actions>
                    </v-card>
                </v-stepper-content>
                <v-stepper-content step="X">
                    <v-card>
                        <v-card-title class="pa-2">
                            <label>Instances</label>
                            <v-spacer></v-spacer>
                        </v-card-title>
                        <v-card-text>
                            <v-container>
                                <v-layout >
                                    <v-col cols="12">
                                        <v-col>
                                            <v-slider v-model="instanceLimit" class="align-center" :max="instanceLimitMax" :min="instanceLimitMin" hide-details thumb-label="always" thumb-size="32">
                                            </v-slider>
                                        </v-col>
                                    </v-col>
                                </v-layout>
                            </v-container>
                        </v-card-text>
                        <v-card-actions>
                            <v-btn color="primary" class="m-0" @click="previousStep">Previous</v-btn>
                            <v-spacer></v-spacer>
                            <v-btn color="primary" class="m-0" @click="nextStep">Next</v-btn>
                        </v-card-actions>
                    </v-card>
                </v-stepper-content>
                <v-stepper-content step="P">
                    <v-card>
                        <v-card-title class="pa-2">
                            <label>Products</label>
                        </v-card-title>
                        <v-data-table dense v-model="productsTable.selected" :single-select="productsTable.singleSelect" show-select item-key="product" :headers="productsTable.headers" :items="productsTable.products" :loading="isBusy" :loading-text="productsTable.loadingText" class="elevation-0">
                        </v-data-table>
                        <v-card-actions>
                            <v-btn color="primary" class="m-0" @click="previousStep">Previous</v-btn>
                            <v-spacer></v-spacer>
                            <v-btn color="primary" class="m-0" @click="nextStep">Next</v-btn>
                        </v-card-actions>
                    </v-card>
                </v-stepper-content>
                <v-stepper-content step="T">
                    <v-row>
                        <v-col>
                            <v-card elevation="0">
                                <v-card-title class="pa-2">
                                    <label>Type</label>
                                    <v-spacer></v-spacer>
                                </v-card-title>
                                <v-data-table dense v-model="typeTable.selected" :single-select="typeTable.singleSelect" show-select item-key="type" :headers="typeTable.headers" :items="typeTable.types" :loading="isBusy" :loading-text="typeTable.loadingText" class="elevation-0">
                                </v-data-table>
                            </v-card>
                        <v-card-actions>
                            <v-btn color="primary" class="m-0" @click="previousStep">Previous</v-btn>
                            <v-spacer></v-spacer>
                            <v-btn color="primary" class="m-0" @click="nextStep">Next</v-btn>
                        </v-card-actions>
                        </v-col>
                    </v-row>
                </v-stepper-content>
                <v-stepper-content step="+">
                    <v-card>
                        <v-card-title class="pa-2">
                            <label>Confirmation</label>
                        </v-card-title>
                        <v-card-text>
                            <label v-html="summaryDescription"/>
                        </v-card-text>
                        <v-card-actions>
                            <v-btn color="primary" class="m-0" @click="previousStep">Previous</v-btn>
                            <v-spacer></v-spacer>
                            <v-btn color="primary" class="m-0" @click="createCodes"><v-icon left>mdi-plus</v-icon>Create</v-btn>
                        </v-card-actions>
                    </v-card>
                </v-stepper-content>
                <v-stepper-content step="L">
                    <v-card>
                        <v-card-title class="pa-2">
                            <label>Results</label>
                        </v-card-title>
                        <v-card-text>
                            <label v-html="resultsDescription"/>
                        </v-card-text>
                        <v-card-actions>
                            <v-btn color="primary" class="m-0" @click="previousStep">Previous</v-btn>
                            <v-spacer></v-spacer>
                            <v-btn color="primary" class="m-0" @click="copyText">Copy License(s) to Clipboard</v-btn>
                        </v-card-actions>
                    </v-card>
                </v-stepper-content>
            </v-stepper>
        </v-card>
    </div>
</template>

<script>

export default {
    name: "LicenseCreate",
    props: {
        editingLicense: {
        },
    },
    data() {
        return {
            title: "LicenseCreate",
            createDescription: "Create",
            isBusy: false,
            dialog: false,
            licenseStep: "C",
            createMin: 1,
            createMax: 100,
            createSlider: 1,
            instanceLimitMin: 0,
            instanceLimitMax: 50,
            instanceLimit: 0,
            dealerTable: {
                selected: [],
                singleSelect: true,
                filter: "",
                searchFor: "",
                itemKey: "dealerId",
                loadingText: "loading dealers",
                headers: [
                    { text: "Dealer", value: "dealer" },
                ],
                dealers: [],
            },
            firmTable: {
                selected: [],
                singleSelect: true,
                filter: "",
                searchFor: "",
                itemKey: "firmGUID",
                loadingText: "loading firms",
                headers: [
                    { text: "Code", value: "firmGUID" },
                    { text: "Firm", value: "firm" },
                    { text: "Expiration Month", value: "expirationMonth" },
                ],
                firms: [],
            },
            typeTable: {
                selected: [],
                singleSelect: true,
                itemKey: "type",
                loadingText: "loading types",
                headers: [
                    { text: "Type", value: "type" },
                ],
                types: [
                    { typeGUID: "FULL", type: "Full" },
                    { typeGUID: "READ_ONLY", type: "Read-Only" },
                    { typeGUID: "XBRL", type: "XBRL" },
                ],
            },
            productsTable: {
                selected: [],
                singleSelect: false,
                itemKey: "product",
                loadingText: "loading products",
                headers: [
                    { text: "Product", value: "product" },
                ],
                products: [
                    { product: "IFRS" },
                    { product: "GRAP" },
                    { product: "RAC" },
                    { product: "CET" },
                    { product: "TVET" },
                    { product: "CLOUD" },
                ],
            },
            creating: {
            },
            expires: "",
            summaryDescription: "",
            resultsDescription: "",
        };
    },
    mounted() {
        this.searchDealers();
    },
    methods: {
        onKey(evt) {
            if (evt.key === "Enter") {
                this.confirmSearchFirms();
            }
        },
        onFirmSearchKey(evt) {
            if (evt.key === "Enter") {
                this.confirmSearchFirms();
            }
        },
        onBackKey() {
            this.$emit("onBackKey");
        },
        onExpirationClick(months) {
            const today = new Date();
            const lastDayOfMonth = new Date(today.getFullYear(), today.getMonth() + months + 1, 1);
            this.expires = lastDayOfMonth.toISOString().substr(0, 10);
        },
        onCountClick(count) {
            this.creating.createSlider = count;
        },
        resetCreate() {
            const today = new Date();
            const lastDayOfMonth = new Date(today.getFullYear(), today.getMonth() + 1, 1);

            this.licenseStep = "C";
            this.creating = {};
            this.expires = lastDayOfMonth.toISOString().substr(0, 10);
            this.creating.cet = false;
            this.creating.grap = false;
            this.creating.ifrs = false;
            this.creating.rac = false;
            this.creating.tvet = false;
            this.creating.cloud = false;
        },
        previousStep() {
            if (this.licenseStep === "L") {
                this.licenseStep = "+";
            }
            else if (this.licenseStep === "+") {
                this.licenseStep = "T";
            }
            else if (this.licenseStep === "T") {
                this.licenseStep = "P";
            }
            else if (this.licenseStep === "P") {
                this.licenseStep = "X";
            }
            else if (this.licenseStep === "X") {
                this.licenseStep = "E";
            }
            else if (this.licenseStep === "E") {
                this.licenseStep = "F";
            }
            else if (this.licenseStep === "F") {
                this.licenseStep = "D";
            }
            else if (this.licenseStep === "D") {
                this.licenseStep = "C";
            }
        },
        nextStep() {
            if (this.licenseStep === "C") {
                this.licenseStep = "D";
            }
            else if (this.licenseStep === "D") {
                if (this.dealerTable.selected.length > 0) {
                    this.licenseStep = "F";
                }
            }
            else if (this.licenseStep === "F") {
                if (this.firmTable.selected.length > 0) {
                    this.licenseStep = "E";
                }
            }
            else if (this.licenseStep === "E") {
                this.licenseStep = "X";
            }
            else if (this.licenseStep === "X") {
                this.licenseStep = "P";
            }
            else if (this.licenseStep === "P") {
                this.licenseStep = "T";
            }
            else if (this.licenseStep === "T") {
                if (this.typeTable.selected.length > 0) {
                    this.setDescription();
                    this.licenseStep = "+";
                }
            }
        },
        createCodes() {
            this.$confirm({
                title: "Confirm Create",
                message: "Are you sure you wish to create?",
            }, (value) => {
                if (value) {
                    this.licenseStep = "L";
                    this.isBusy = true;
                    this.resultsDescription = "Please wait...";

                    this.$http
                        .post(`/api/license/create`, {
                            application: {
                                applicationGUID: "DX",
                            },
                            dealerGUID: this.dealerTable.selected[0].dealerGUID,
                            firmGUID: this.firmTable.selected[0].firmGUID,
                            licenseTypeGUID: this.typeTable.selected[0].typeGUID,
                            licenseCount: this.creating.createSlider,
                            instanceLimit: this.instanceLimit,
                            expires: this.expires,
                            products: {
                                cet: this.creating.cet,
                                ifrs: this.creating.ifrs,
                                grap: this.creating.grap,
                                rac: this.creating.rac,
                                tvet: this.creating.tvet,
                                cloud: this.creating.cloud,
                            },
                        })
                        .then((response) => {
                            this.isBusy = false;
                            this.resultsDescription = response.data.join("<br/>");

                            this.$ga.event({
                                eventCategory: "licenses",
                                eventAction: "create",
                            });
                        })
                        .catch((err) => {
                            this.isBusy = false;
                            this.$alert({ type: "error", title: "Save Failed", message: err.response.data.exceptionMessage });
                        });
                }
            });
        },
        searchDealers() {
            this.isBusy = true;
            this.dealerTable.dealers = [];
            this.dealerTable.selected = [];

            this.$http
                .get(`/api/dealer/list/`)
                .then((response) => {
                    this.dealerTable.dealers = response.data;
                    this.isBusy = false;
                })
                .catch((err) => {
                    this.isBusy = false;
                    if (err.response.status === 401) {
                        this.$router.push({ name: "login" });
                    }
                    else {
                        this.$alert({ type: "error", title: "Search Failed", message: err.response.data.exceptionMessage });
                    }
                });
        },
        confirmSearchFirms() {
            if (this.firmSearch === "") {
                this.$confirm({
                    title: "Confirm Search",
                    message: "Are you sure you wish to load all firms?",
                }, (value) => {
                    if (value) {
                        this.searchFirms();
                    }
                });
            }
            else {
                this.searchFirms();
            }
        },
        searchFirms() {
            this.isBusy = true;
            this.firmTable.firms = [];
            this.firmTable.selected = [];

            this.$http
                .get(`/api/firm/search/${this.firmTable.searchFor}/`)
                .then((response) => {
                    this.firmTable.firms = response.data;
                    this.isBusy = false;
                })
                .catch((err) => {
                    this.isBusy = false;
                    this.$alert({ type: "error", title: "Search Failed", message: err.response.data.exceptionMessage });
                });
        },
        setDescription() {
            this.licenseStep = "C";

            this.creating.cet = (this.productsTable.selected.filter(e => e.product === "CET").length > 0);
            this.creating.grap = (this.productsTable.selected.filter(e => e.product === "GRAP").length > 0);
            this.creating.ifrs = (this.productsTable.selected.filter(e => e.product === "IFRS").length > 0);
            this.creating.rac = (this.productsTable.selected.filter(e => e.product === "RAC").length > 0);
            this.creating.tvet = (this.productsTable.selected.filter(e => e.product === "TVET").length > 0);
            this.creating.cloud = (this.productsTable.selected.filter(e => e.product === "CLOUD").length > 0);

            this.summaryDescription = `Count: ${this.creating.createSlider} license(s) <br/><br/>
                                        Type: ${this.typeTable.selected[0].typeGUID}<br/>
                                        Dealer: ${this.dealerTable.selected[0].dealerGUID} <br/>
                                        Expires: ${this.expires} <br/>
                                        Firm: ${this.firmTable.selected[0].firmGUID}<br/>
                                        Instance Limit: ${this.instanceLimit}<br/><br/>
                                        Products: <br/>
                                        IFRS - ${this.creating.ifrs}<br/>
                                        GRAP - ${this.creating.grap}<br/>
                                        RAC - ${this.creating.rac}<br/>
                                        CET - ${this.creating.cet}<br/>
                                        TVET - ${this.creating.tvet}<br/>
                                        CLOUD - ${this.creating.cloud}<br/><br/>`;
        },
        copyText() {
            let newLicenses = this.resultsDescription;
            for (let counter = 0; counter < this.creating.createSlider; counter += 1) {
                newLicenses = newLicenses.replace("<br/>", "\n");
            }
            navigator.clipboard.writeText(newLicenses);
        },
    },
};
</script>

<style lang="scss" scoped>
.v-slider__thumb-label.primary
{
    font-size: 60px !important;
}
.v-slider__thumb-label {
    font-size: 48px !important;
}
</style>
